import  "./poster.css"
function Poster(){
    return(
        <>
        <div className="poster">
            <div className="continer">
  <h1>Your care is our responsibility, and your health is our priority</h1>
  <h1>Our Priority</h1>
  <p>
    We provide comprehensive medical services with the highest quality standards, 
    delivered by a distinguished team of specialized doctors, to always be your 
    first choice for comfort and health.
  </p>
</div>
        </div>
        </>
    )
}
export default Poster